import { Table as SemanticTable } from "semantic-ui-react";

export const Table = SemanticTable;
Table.Body = SemanticTable.Body;
Table.Header = SemanticTable.Header;
Table.Row = SemanticTable.Row;
